import { restoreCssLinks } from "./cssInliner";

const TIINY_PATTERNS = [
  /<style id="tiiny-style">[\s\S]*?<\/style>/,
  /tiinyeditabletext/g,
  /tiinyedit/g,
  /tiinyeditablefocused/g,
  /tiinyeditableimage/g,
  /\sdata-tiiny-click-handler=("[^"]*"|'[^']*')/g,
  /contenteditable="true"/g,
  /contenteditable="false"/g,
];

export function cleanHtmlForPublish(html) {
  let result = html;

  TIINY_PATTERNS.forEach((pattern) => {
    result = result.replace(pattern, "");
  });

  result = restoreCssLinks(result);

  if (!result.startsWith("<!DOCTYPE html>")) {
    result = `<!DOCTYPE html>${result}`;
  }

  return result;
}

export function cleanIframeClasses(iframeDoc) {
  const htmlElement = iframeDoc.querySelector("html");
  const bodyElement = iframeDoc.querySelector("body");

  if (htmlElement) htmlElement.removeAttribute("class");
  if (bodyElement) bodyElement.removeAttribute("class");
}

export function resetEditableElements(iframeDoc) {
  const editableElements = iframeDoc.querySelectorAll(
    '[contenteditable="true"]',
  );
  editableElements.forEach((element) => {
    element.contentEditable = false;
    element.classList.remove(
      "tiinyeditabletext",
      "tiinyedit",
      "tiinyeditablefocused",
    );
  });

  const unEditableElements = iframeDoc.querySelectorAll(
    '[contenteditable="false"]',
  );
  unEditableElements.forEach((element) => {
    element.contentEditable = false;
    element.classList.remove(
      "tiinyeditabletext",
      "tiinyedit",
      "tiinyeditablefocused",
    );
  });

  const elementsWithOutline = iframeDoc.querySelectorAll(".tiinyeditabletext");
  elementsWithOutline.forEach((element) => {
    element.classList.remove(
      "tiinyeditabletext",
      "tiinyedit",
      "tiinyeditablefocused",
    );
  });
}
